import { CreateEditorMode } from '../EditorModeInfo';

export const MeetingMode = CreateEditorMode(
    'meeting',
    'Meeting Mode',
    'Switch to meeting mode when you are ready to run your meeting or workshop.',
    'deqo://icons/sln/07-work-office-companies/team-meeting'
);
